import React, { useState } from "react";
import { ChevronRight, ChevronDown, Loader2 } from "lucide-react";
import styles from "./TreeNode.module.css";

export const TreeNode = ({ node, level, onExpand }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [children, setChildren] = useState([]);

  const handleClick = async () => {
    if (!node.hasChildren) return;
    
    if (!isExpanded && children.length === 0) {
      setIsLoading(true);
      try {
        const childNodes = await onExpand(node.id);
        setChildren(childNodes);
        setIsExpanded(true);
      } catch (error) {
        console.error("Failed to load children:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsExpanded(!isExpanded);
    }
  };

  const isMobile = window.innerWidth < 768;
  const indentWidth = level * (isMobile ? 12 : 20);

  return (
    <div className="position-relative">
      {/* Vertical connecting line */}
      {level > 0 && (
        <div
          className={styles.verticalLine}
          style={{ 
            left: `${indentWidth - 12}px`
          }}
        />
      )}

      {/* Horizontal connecting line */}
      {level > 0 && (
        <div
          className={styles.horizontalLine}
          style={{ 
            left: `${indentWidth - 12}px`
          }}
        />
      )}

      {/* Node content */}
      <div
        className={styles.nodeBox} 
        style={{ 
          marginLeft: `${indentWidth}px`,
          cursor: node.hasChildren ? 'pointer' : 'default'
        }}
        onClick={handleClick}
        // onMouseEnter={(e) => {
        //   if (node.hasChildren) {
        //     e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)';
        //   }
        // }}
        // onMouseLeave={(e) => {
        //   if (level !== 0) {
        //     e.currentTarget.style.backgroundColor = ' rgba(0, 0, 255, 0.05)';
        //   }
        // }}
      >
        {/* Expand/collapse icon */}
        <div className={styles.iconContainer}>
          {isLoading ? (
            <Loader2 className={`${styles.spin} text-primary`} size={16} />
          ) : node.hasChildren ? (
            isExpanded ? (
              <ChevronDown className="text-primary" size={16} />
            ) : (
              <ChevronRight className="text-primary" size={16} />
            )
          ) : (
            <div 
              className={styles.smallDot}
            />
          )}
        </div>

        {/* Node label */}
        <div className={styles.labelContainer}>
          <div
            className={`fw-medium d-flex align-items-center text-primary fs-6
            }`}
            style={{ position: "relative" }}
          >
            {/* <span>{node.label1}</span>
            <span className="ms-3 fw-bold" style={{ flexShrink: 0, fontSize: '0.9rem' }}>
              {node.label2}
            </span> */}
             {/* Left label */}
            <span className={styles.labelLeft}>
              {node.label1}
            </span>

            {/* Right label - absolutely positioned */}
            <span
              className={styles.labelRight}
            >
              {node.label2}
            </span>
          </div>
          {node.metadata && (
            <div className={styles.metadata}
        >
              {/* {Object.entries(node.metadata)
                // .slice(0, 2)  text-truncate
                .map(([key, value]) => `${key}: ${value}`)
                .join(" • ")

                // .map(([key, value]) => (
                //     <div key={key}>
                //         <strong>{key}:</strong> {value}
                //     </div>
                // ))
                
              } */}
              {Object.entries(node.metadata).map(([key, value], index) => (
                <span key={index} style={{ marginRight: "6px" }}>
                  <strong>{key}:</strong> {value}
                  {index < Object.entries(node.metadata).length - 1 && "  • "}
                </span>
              ))}

                
            </div>
          )}
        </div>

        {/* Visual indicator for expandable nodes */}
        {/* {node.hasChildren && !isExpanded && (
          <span className="badge bg-secondary" style={{ flexShrink: 0, fontSize: '0.75rem' }}>
            +
          </span>
        )} */}
      </div>

      {/* Children */}
      {isExpanded && children.length > 0 && (
        <div className="position-relative">
          {children.map((child) => (
            <TreeNode
              key={child.id}
              node={child}
              level={level + 1}
              onExpand={onExpand}
            />
          ))}
        </div>
      )}


    </div>
  );
};
